import React from "react";
import {
  FaSms,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaTelegramPlane,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa"; // Importing icons
import "./ContactButtons.css";
import { FaAddressBook, FaQrcode, FaInfoCircle } from "react-icons/fa";

function NextButtons() {
  return (
    <>
      <div className="contact-buttonsX" style={{ marginTop: "3vh" }}>
        <button>
          <FaAddressBook  className="icons" />
          <span>Save</span>
        </button>
        <button>
          <FaInfoCircle  className="icons" />
          <span>About</span>
        </button>
        <button>
          <FaQrcode  className="icons" />
          <span>Scan</span>
        </button>
      </div>
    </>
  );
}

export default NextButtons;
